import styled from "styled-components";

const StyledProductWrapper = styled.div`
  .product_total_count {
    text-wrap: nowrap;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.83px;
    text-align: left;
  }
  .product_filter_action_conatiner {
    display: flex;
    justify-content: end;
  }
  .add_productlist_button {
    width: 100%;
    display: flex;
    justify-content: end;
  }
  .view_product_goback {
    display: flex;
    align-items: center;
    gap: 10px;
    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 20.83px;
      text-align: left;
      margin-bottom: 0px;
      cursor: pointer;
    }
    .right_out_icon {
      font-size: 16px;
      // font-weight: 400;
    }
    storng {
      font-size: 16px;
    }
  }
  .form_button_section {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: end;
    margin-top: 12px;
  }
  .table_action_icons {
    display: flex;
    gap: 16px;
  }
  .actionicon_style {
    font-size: 20px;
    color: #2d53da;
    cursor: pointer;
  }
  .delete_modal_footer {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 16px;
  }
  .cancel_button_style {
    color: #2d53da !important;
    border: 1px solid #2d53da !important;
    width: 110px;
  }
  .logout-button {
    background-color: #2d53da;
    color: white;
    border: none;
    width: 110px;
    outline: none !important;
  }
  .logout-button:hover {
    background-color: #2d53da !important;
    color: white !important;
  }
  .logout-button:focus,
  .logout-button:active {
    border: 1px solid #2d53da !important;
    background-color: white !important;
  }
`;

export default StyledProductWrapper;
